/** Auditoría de pláticas con AROC (ISO 27001): sólo admins, nace apagada. */
import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { AnalysisMessage } from "@/api/types";

export interface PlaticaAuditada {
  id: string;
  dueno: string | null;
  trigger_type: string;
  status: string;
  started_at: string;
  finished_at: string | null;
  titulo: string;
  mensajes: number;
  tools: string[];
  tokens: number;
  costo_usd: number | null;
  costo_incompleto: boolean;
}

export function useAuditoriaEstado() {
  return useQuery({
    queryKey: ["auditoria-platicas", "estado"],
    queryFn: () => api<{ enabled: boolean; aviso: string | null }>("/api/v1/auditoria/platicas/estado"),
    staleTime: 5 * 60 * 1000,
  });
}

export function useAuditoriaPlaticas(filtros: { dias: number; usuario: string }, enabled: boolean) {
  const qs = new URLSearchParams({ dias: String(filtros.dias) });
  if (filtros.usuario) qs.set("usuario", filtros.usuario);
  return useQuery({
    queryKey: ["auditoria-platicas", filtros],
    queryFn: () =>
      api<{ total: number; items: PlaticaAuditada[] }>(`/api/v1/auditoria/platicas?${qs.toString()}`),
    enabled,
  });
}

export function usePlaticaAuditada(id: string | null) {
  return useQuery({
    queryKey: ["auditoria-platicas", "una", id],
    queryFn: () =>
      api<PlaticaAuditada & { messages: AnalysisMessage[] }>(`/api/v1/auditoria/platicas/${id}`),
    enabled: id !== null,
  });
}
